import styled from 'styled-components'
import { useHistory } from 'react-router-dom'

import { Title } from './components/index.jsx'
import onboardingMoney from 'images/onboarding_money.png'
import onboardingMotivation from 'images/onboarding_motivation.png'
import rightArrow from 'images/icon/arrow_right_4e4e4e-25x48.png'

const OnboardingInit = () => {
  const history = useHistory()

  return (
    <ColumnBetweenContainer>
      <TitleWrapper>
        <Title>
          모티너스에서
          <br/>
          당신의 습관을 성공적으로
          <br/>
          바꿔드릴게요 ✨
        </Title> 
      </TitleWrapper>

      <Content>
        <Question>
          "운동해야지!" 결심한 당신,
          <br/>
          하지만 잘 안하게 되는 이유는..?
        </Question>

        <Options>
          <Option onClick={() => history.push('/onboarding/step1-A')}>
            <IconWrapper>
              <img src={onboardingMoney} alt={'돈'} style={{ width: 'calc(100vw * (58 / 375))', height: 'calc(100vw * (58 / 375))' }} />
            </IconWrapper>

            <AnswerWrapper>
              <Answer>시작할 때 돈이 들어 망설여져...</Answer>
              <RightArrow />
            </AnswerWrapper>
          </Option>

          <Option onClick={() => history.push('/onboarding/step1-B')}>
            <IconWrapper>
              <img src={onboardingMotivation} alt={'무기력'} style={{ width: 'calc(100vw * (53 / 375))', height: 'calc(100vw * (53 / 375))' }} />
            </IconWrapper>

            <AnswerWrapper>
              <Answer>큰 보상이 없으니 금방 포기해...</Answer>
              <RightArrow />
            </AnswerWrapper>
          </Option>
        </Options>

        <AlreadySignup>
          <AlreadySignupText>이미 회원가입을 했다면?</AlreadySignupText>
          <AlreadySignupBtn onClick={() => history.push('/social')}>로그인</AlreadySignupBtn>
        </AlreadySignup>
      </Content>
    </ColumnBetweenContainer>
  )
}

const ColumnBetweenContainer = styled.div`
  height: 100vh;
  padding: 50px 20px 25px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const TitleWrapper = styled.div`
  margin-bottom: 20px;
`

const Content = styled.div``

const Question = styled.div`
  font-weight: 600;
  font-size: calc(100vw * (18 / 375));
  line-height: calc(100vw * (26 / 375));
  margin-bottom: 16px;
`

const Options = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
`

const Option = styled.div`
  flex-shrink: 1;
  min-width: calc(100vw * (118 / 375));
  width: 48%;
  height: calc(100vw * (160 / 375));
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f7f7f7;
  border-radius: 14px;
  padding: 0 14px 14px;

  :first-child {
    margin-right: 4px;
  }
`

const IconWrapper = styled.div`
  height: calc(100vw * (58 / 375));
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
`

const AnswerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`

const Answer = styled.div`
  font-weight: 600;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (24 / 375));
  color: #4E4E4E;
  word-break: keep-all;
  white-space: pre-wrap;
`

const RightArrow = () => (
  <div
    style={{
      height: 'calc(100vw * (24 / 375))',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginLeft: '2px',
    }}
  >
    <img src={rightArrow} alt={'>'} style={{ width: 'calc(100vw * (6 / 375))' }} />
  </div>
)

const AlreadySignup = styled.div`
  margin-top: 25px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`

const AlreadySignupText = styled.div`
  margin-right: calc(100vw * (6 / 375));
  color: #707070;
  font-weight: 400;
  font-size: calc(100vw * (12/ 375));
  line-height: calc(100vw * (15 / 375));
`

const AlreadySignupBtn = styled.button`
  color: #707070;
  font-weight: 600;
  font-size: calc(100vw * (12/ 375));
  line-height: calc(100vw * (15 / 375));
  text-decoration-line: underline;
`

export default OnboardingInit
